import { render, staticRenderFns } from "./clientSelectGrid.vue?vue&type=template&id=a2059c1c&"
import script from "./clientSelectGrid.vue?vue&type=script&lang=js&"
export * from "./clientSelectGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports